//Libs
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { Flip } from 'gsap/Flip';

// Let's try to import MorphSVGPlugin more safely
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

try {
	gsap.registerPlugin( ScrollTrigger, ScrollSmoother, Flip, MorphSVGPlugin, ScrollToPlugin );
} catch ( e ) {
	console.warn( 'Ошибка регистрации плагинов GSAP:', e );
	gsap.registerPlugin( ScrollTrigger, ScrollSmoother, Flip, ScrollToPlugin );
}

import Swiper from 'swiper';

import BackgroundBlur from './layout/BackgroundBlur.js';
import LanguageScript from './layout/language.js';
import Header from './layout/Header.js';
import Music from './layout/Music.js';
import Forms from './layout/Forms.js';
import Scroll from './layout/Scroll.js';
import Anchors from './layout/Anchors.js';
import TabsMenu from './layout/TabsMenu.js';
import HorizontalScroll from './layout/HorizontalScroll.js';
import SwiperSliders from './layout/SwiperSliders.js';
import Tabs from './layout/Tabs.js';
import Modal from './layout/Modal.js';
import Shop from './layout/Shop.js';
import scrollShop from './layout/scroll-shop.js';
import VATValidation from './layout/VATValidation.js';


( ( $ ) => {
	$( () => {
		try {
			BackgroundBlur( $ );
			LanguageScript( $ );
			Header( $ );
			Music( $ );
			Forms( $ );
			Scroll( $ );
			Anchors( $ );
			TabsMenu( $ );
			HorizontalScroll( $ );
			SwiperSliders( $ );
			Tabs( $ );
			Modal( $ );
			Shop($);
			scrollShop($);
			VATValidation($);
			
		} catch ( e ) {
			console.error( 'Ошибка инициализации модулей:', e );
		}
	} );
	const shopSection = document.querySelector('.brxe-section.shop');
	if(shopSection) {
		shopSection.style.overflow = 'hidden';
	}
	let itemsL = gsap.utils.toArray('.left-product .product-item:not(:first-child)');
	let itemsR = gsap.utils.toArray('.right-product .product-item:not(:first-child)'); 
	itemsL.forEach(item => {
		gsap.fromTo( item , {x: "-100vw", autoAlpha: 0}, {
			autoAlpha: 1,
			x: 0,
			scrollTrigger:{
				trigger: item,
				// start: "top 100px",
				end: 'bottom bottom',
				scrub: 1.5,
			}
		});
	});
	itemsR.forEach(item => {
		gsap.fromTo( item , {x: "100vw", autoAlpha: 0}, {
			autoAlpha: 1,
			x: 0, 
			scrollTrigger:{
				trigger: item,
				// start: "top 100px",
				end: 'bottom bottom',
				scrub: 1.5, 
			}
		});
	});
	if ($('.input input').length) {
        $('.input input').focus(function () {
            $(this).parent().addClass('focus')
        })
        $('.input input').blur(function () {
            if ($(this).val() == 0) {
                $(this).parent().removeClass('focus')
            }
        });
        $('.input input').each(function () {
            if ($(this).val() == 0) {
                $(this).parent().removeClass('focus')
            } else {
                $(this).parent().addClass('focus')
            }
        });
    }
} )( jQuery );
